import { render, staticRenderFns } from "./AddProductColorComponent.vue?vue&type=template&id=b1add7ac&scoped=true"
import script from "./AddProductColorComponent.vue?vue&type=script&lang=js"
export * from "./AddProductColorComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1add7ac",
  null
  
)

export default component.exports